export default __webpack_public_path__ + "static/media/street_texture.77674490.jpg";